import {
	type Dispatch,
	type ReactNode,
	type SetStateAction,
	useState,
} from 'react';
import { createContext } from 'react';
import { STORAGE_KEYS } from '../hooks/useAuth';

type ContextValues = {
	role: string;
	organisation: string;
	isAuth: boolean;
};

export const defaultContextValues: ContextValues = {
	role: 'guest',
	organisation: '',
	isAuth: false,
};

export type ContextType = {
	context: ContextValues;
	setContext: Dispatch<SetStateAction<ContextValues>>;
};

export const MedeposContext = createContext<ContextType>({
	context: defaultContextValues,
	setContext: () => {},
});

export function ContextProvider({ children }: { children: ReactNode }) {
	const [context, setContext] = useState({
		role: localStorage.getItem(STORAGE_KEYS.role) ?? defaultContextValues.role,
		organisation:
			localStorage.getItem(STORAGE_KEYS.organisation) ??
			defaultContextValues.organisation,
		isAuth: localStorage.getItem(STORAGE_KEYS.isAuth) === 'true',
	});

	return (
		<MedeposContext.Provider value={{ context, setContext }}>
			{children}
		</MedeposContext.Provider>
	);
}
